<template lang="pug">
.about__container.row-container
  .col-container.col-4.about__sidebar
    h1.about__title.about__title_desktop {{ title }}
    .about__subtitle.about__subtitle_desktop(v-html="subtitle")

    h3.about__section-title Мы используем
    .about__stek
      picture
        source(type="image/webp" srcset="~assets/images/png/postgresql.webp")
        source(type="image/png" srcset="~assets/images/png/postgresql.png")
        img(src="~assets/images/png/postgresql.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/python.webp")
        source(type="image/png" srcset="~assets/images/png/python.png")
        img(src="~assets/images/png/python.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/amazon.webp")
        source(type="image/png" srcset="~assets/images/png/amazon.png")
        img(src="~assets/images/png/amazon.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/celery.webp")
        source(type="image/png" srcset="~assets/images/png/celery.png")
        img(src="~assets/images/png/celery.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/postgis.webp")
        source(type="image/png" srcset="~assets/images/png/postgis.png")
        img(src="~assets/images/png/postgis.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/yandexkassa.webp")
        source(type="image/png" srcset="~assets/images/png/yandexkassa.png")
        img(src="~assets/images/png/yandexkassa.webp").about__stek-img
      picture
        source(type="image/webp" srcset="~assets/images/png/mailgun.webp")
        source(type="image/png" srcset="~assets/images/png/mailgun.png")
        img(src="~assets/images/png/mailgun.webp").about__stek-img
    h3(v-if="!isFormSubmitted").about__section-title Напишите нам!
    Form(:value="form" @submitted="isFormSubmitted=true" v-if="!isFormSubmitted").contact__form
    template(v-else)
      h1.about__submitted-title
        | Спасибо
        br
        | за обращение!
      p.about__submitted-subtitle
        | Мы свяжемся с вами
        br
        | в ближайшее время

    p.about__text Обещанный абзац текста на тему технологий, которыми мы владеем профессионально:
    ol.about__stek-list
      li.about__stek-list-item Django
      li.about__stek-list-item Python
      li.about__stek-list-item Nginx
      li.about__stek-list-item PostgreSQL
      li.about__stek-list-item PostGIS
      li.about__stek-list-item JavaScript
      li.about__stek-list-item Honestly =)
  .col-container.col-7.about__content
    h1.about__title.about__title_mobile {{ title }}
    .about__subtitle.about__subtitle_mobile(v-html="subtitle")
    ContentParser(:content="content")
  .col-container.col.about__footer
    BaseFooter(:formValue="footer_data")
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAboutStore } from '~~/stores/about'

const isFormSubmitted = ref(false)

const aboutStore = useAboutStore()
await aboutStore.setAboutPage()
const {title, subtitle, content, form, footer_data, meta, og} = storeToRefs(aboutStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>


<style lang="scss" scoped>
.about {

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: $breakpoint-medium) {
      flex-direction: row;
    }

    @media (min-width: 1024px) and (max-width: 1279px) {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__content {
    margin-bottom: 40px;
    order: 1;

    @media (min-width: $breakpoint-medium) {
      margin-bottom: 0;
      order: 2;
    }
  }

  &__sidebar {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    order: 2;

    @media (min-width: $breakpoint-medium) {
      display: block;
      order: 1;
    }
  }

  &__title,
  &__subtitle {
    color: $primary;

    &_desktop {
      display: none;

      @media (min-width: $breakpoint-medium) {
        display: block;
      }
    }

    &_mobile {

      @media (min-width: $breakpoint-medium) {
        display: none;
      }
    }
  }

  &__title {
    margin-bottom: 10px;
    font-size: 34px;
  }

  &__subtitle {
    margin-bottom: 210px;
    max-width: 215px;

    &_mobile {
      margin-bottom: 50px;
      width: 100%;
      max-width: 100%;
    }
  }

  &__section-title {
    color: $primary;
    text-transform: uppercase;
    margin-bottom: 30px;
  }

  &__stek {
    align-self: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 40px;
    max-width: 200px;

    @media (min-width: $breakpoint-medium) {
      margin-bottom: 300px;
    }
  }

  &__stek-img {
    margin-bottom: 30px;

    &:last-of-type {
      margin-bottom: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__contact-form {
    margin-bottom: 40px;

    @media (min-width: $breakpoint-medium) {
      margin-bottom: 740px;
    }
  }

  &__text {
    color: $primary;
    max-width: 215px;
    margin-bottom: 30px;
    margin-top: 40px;
  }

  &__stek-list {
    color: $primary;
    padding-left: 16px;
  }

  &__submitted-title {
    color: $primary;
    margin-bottom: 25px;

    @media (min-width: $breakpoint-xlarge) {
      margin-top: 255px;
    }
  }

  &__submitted-subtitle {
    color: $primary;
  }

  &__footer {
    order: 6;
  }
}
</style>
